

import logo from 'assets/logo.svg'
import { useEffect, useState } from 'react';
import { Dialog } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import { Protect, SignedIn, UserButton } from '@clerk/clerk-react';
import { useUserStore } from '@/defines/store/userStore';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useViewDataStore } from '@/defines/store/viewDataStore';

export default function ManagerNavbar() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
    const navigate = useNavigate();

    useEffect(() => {
        if (!useUserStore.getState().isMedicalCenter && !useUserStore.getState().isAnesthesiologist && !useUserStore.getState().isAdmin) {
            const href = window.location.href;
            if (href.indexOf('') !== -1) {
                navigate('/after-login');
            }
        }
    }, [])

    const location = useLocation();

    useEffect(() => {
        console.log(`[ManagerNavbar] location.state?.message: ${location.state?.message}`);
        if (location.state?.message) {
            toast.error(location.state.message);
        }
        console.log(`[ManagerNavbar] useViewDataStore.message: ${useViewDataStore.getState().messageAfterRedirect}`);
        if (useViewDataStore.getState().messageAfterRedirect) {
            toast.error(useViewDataStore.getState().messageAfterRedirect);
            useViewDataStore.setState({ messageAfterRedirect: '' });
        }
    }, [location]);

    return (
        <div className="bg-white">
            <header className="relative inset-x-0 top-0 z-10">
                <nav
                    className="flex items-center justify-between p-6 lg:px-8"
                    aria-label="Global"
                >
                    <div className="flex lg:flex-1">
                        <a href="/" className="-m-1.5 p-1.5">
                            <span className="sr-only">麻醉安全通-管理者頁面</span>
                            <img
                                className="w-auto h-14 sm:h-18 md:h-20 lg:h-22"
                                src={logo}
                                alt="麻醉安全通"
                            />
                        </a>
                    </div>
                    <div className="flex lg:hidden">
                        <div>
                            <p className="m-3 text-2xl font-bold tracking-tight text-center text-gray-900 sm:text-2xl md:text-3xl">
                                麻醉安全通
                            </p>
                            <p className="m-3 text-base font-bold tracking-tight text-center text-gray-900 sm:text-2xl md:text-3xl">
                                手術治病 麻醉保命
                            </p>
                        </div>
                    </div>
                    <div className="flex lg:hidden">
                        <button
                            type="button"
                            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
                            onClick={() => setMobileMenuOpen(true)}
                        >
                            <span className="sr-only">Open main menu</span>
                            <Bars3Icon
                                className="w-6 h-6"
                                aria-hidden="true"
                            />
                        </button>
                    </div>
                    <div className="hidden lg:flex lg:gap-x-12">
                        <Protect
                            condition={(has) => has({ role: 'org:anesthes_content_manager' }) || has({ role: 'org:medicalcenter_content_manager' })}>
                            <a key="admin" href="/admin/personal-info"
                                className="text-lg font-semibold leading-6 text-gray-900">
                                個人資料
                            </a>
                        </Protect>

                        <Protect
                            condition={(has) => has({ role: 'org:anesthes_content_manager' }) || has({ role: 'org:medicalcenter_content_manager' })}>
                            <a key="admin" href="/admin/introduce-editor"
                                className="text-lg font-semibold leading-6 text-gray-900">
                                自介資料
                            </a>
                        </Protect>

                        <Protect role="org:admin">
                            <a key="admin" href="/admin/anesth-list"
                                className="text-lg font-semibold leading-6 text-gray-900">
                                麻醉醫師列表
                            </a>
                            <a key="admin" href="/admin/medical-center-list"
                                className="text-lg font-semibold leading-6 text-gray-900">
                                醫院列表
                            </a>
                            <a key="admin" href="/admin/organization"
                                className="text-lg font-semibold leading-6 text-gray-900">
                                組織
                            </a>
                        </Protect>
                    </div>
                    <div className="hidden lg:flex lg:flex-1 lg:justify-end">
                        <SignedIn>
                            <UserButton />
                        </SignedIn>
                    </div>
                </nav>
                <Dialog
                    as="div"
                    className="lg:hidden"
                    open={mobileMenuOpen}
                    onClose={setMobileMenuOpen}
                >
                    <div className="fixed inset-0 z-50" />
                    <Dialog.Panel className="fixed inset-y-0 right-0 z-50 w-full px-6 py-6 overflow-y-auto bg-white sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
                        <div className="flex items-center justify-between">
                            <a href="#" className="-m-1.5 p-1.5">
                                <span className="sr-only">麻醉安全通</span>
                                <img
                                    className="w-auto h-14 sm:h-18 md:h-20 lg:h-22"
                                    src={logo}
                                    alt="麻醉安全通"
                                />
                            </a>
                            <button
                                type="button"
                                className="-m-2.5 rounded-md p-2.5 text-gray-700"
                                onClick={() => setMobileMenuOpen(false)}
                            >
                                <span className="sr-only">Close menu</span>
                                <XMarkIcon
                                    className="w-6 h-6"
                                    aria-hidden="true"
                                />
                            </button>
                        </div>
                        <div className="flow-root mt-6">
                            <div className="-my-6 divide-y divide-gray-500/10">
                                <div className="py-6 space-y-2">
                                    <Protect
                                        condition={(has) => has({ role: 'org:anesthes_content_manager' }) || has({ role: 'org:medicalcenter_content_manager' })}>
                                        <a key="admin" href="/admin/personal-info"
                                            className="text-lg font-semibold leading-6 text-gray-900">
                                            個人資料
                                        </a>
                                    </Protect>

                                    <Protect
                                        condition={(has) => has({ role: 'org:anesthes_content_manager' }) || has({ role: 'org:medicalcenter_content_manager' })}>
                                        <a key="admin" href="/admin/introduce-editor"
                                            className="text-lg font-semibold leading-6 text-gray-900">
                                            自介資料
                                        </a>
                                    </Protect>
                                    <Protect role="org:admin">
                                        <a key="admin" href="/admin/anesth-list"
                                            className="block px-3 py-2 -mx-3 text-lg font-semibold leading-7 text-gray-900 rounded-lg hover:bg-gray-50">
                                            麻醉醫師列表
                                        </a>
                                        <a key="admin" href="/admin/medical-center-list"
                                            className="block px-3 py-2 -mx-3 text-lg font-semibold leading-7 text-gray-900 rounded-lg hover:bg-gray-50">
                                            醫院列表
                                        </a>
                                        <a key="admin" href="/admin/organization"
                                            className="block px-3 py-2 -mx-3 text-lg font-semibold leading-7 text-gray-900 rounded-lg hover:bg-gray-50">
                                            組織
                                        </a>
                                    </Protect>
                                </div>
                                <SignedIn>
                                    <UserButton />
                                </SignedIn>

                            </div>
                        </div>
                    </Dialog.Panel>
                </Dialog>
            </header>
        </div>
    );
}
